import React from "react";
import classes from "./BorrowerFrequentlyAskedQuestions.module.css";
import Accordion from "./Helper-Components/Accordion";

function BorrowerFrequentlyAskedQuestions() {
  return (
    <>
      <div className={classes.questionsDetails}>
        <h4 className={classes.h4}>BorrowerFrequentlyAskedQuestions</h4>
        <Accordion header={"How do I schedule an ACH Payment?"}>
          Go to your loan page and click on the ACH button.
        </Accordion>
        <Accordion
          header={
            "Where do I download or view my monthly statement of account?"
          }
        >
          You can find this information under Attachments on your loan page.
        </Accordion>
        <Accordion
          header={"Where can I mail payment and who do I make it payable to?"}
        >
          <p>
            Though we find that ACH is faster and easier, if you prefer to mail
            in your payment, please make your check payable to{" "}
            <strong>Superior Loan Servicing</strong>, and send it to:
          </p>
          <p>
            Superior Loan Servicing 7525 <br /> Topanga Canyon Blvd. <br />{" "}
            Canoga Park, CA 91303
          </p>
          <p>
            <strong>
              Be sure to include your loan number (or property address) on the
              check.
            </strong>
          </p>
        </Accordion>
        <Accordion header={"When is my payment posted to my loan?"}>
          All payments are posted when received in our office. ACH Payments are
          credited the following business day after the scheduled date.
        </Accordion>
      </div>
      <style>
        {`
        .accordion-button:not(.collapsed) {
    color:#ff8057;
    background-color: #fff;
    font-weight: 700;
} 
.accordion-body {
     padding: 1rem 2rem;
} }`}
      </style>
    </>
  );
}

export default BorrowerFrequentlyAskedQuestions;
